export const FAQType_Parent = 'parent';
export const FAQType_Child = 'child';
export const FAQType_VideoChild = 'video-child';
export const FAQTypes = [FAQType_Parent, FAQType_Child, FAQType_VideoChild];
//# sourceMappingURL=types.js.map